//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            popup: false,
            acticeIndex: 0,
            regionList: [],
            list: [{
                regionId: '',
                regionName: '请选择'
            }]
        }
    },
    methods: {
        showPopup(addressList) {
            console.log(addressList)
            this.popup = true;
            if(addressList && addressList.length > 0) {
                this.list = addressList;
                this.acticeIndex = addressList.length - 1;
                this.loadData(addressList[addressList.length - 2].regionId);
            } else {
                this.loadData();
            }
        },
        showHandle() {
            var $sp =$('.popup-address-add');
            $('body').append($sp);
            $(".vux-popup-mask").css('z-index', 504);
        },
        closePopup() {
            $(".vux-popup-mask").css('z-index', -1);
            this.acticeIndex = 0;
            this.list = [{
                regionId: '',
                regionName: '请选择'
            }];
            this.regionList = [];
        },
        loadData(regionId) {
            let that = this;
            that.$axios.get("/api/v1.0/region", {
                params: {
                    regionId:regionId||-1,
                    type:1
                }
            }).then(function (res) {
                if (res.status == 200) {
                    that.regionList = res.body.regionList;
                    that.setCheck(); 
                }
            })
        },
        setCheck() {
            let that = this;
            var regionList = that.regionList.map((item) => {
                var flag = false;
                that.list.forEach((one) => {
                    if(item.regionId == one.regionId) {
                        flag = true;
                    }
                })
                item.checked = flag;
                return item;
            });
            that.regionList = JSON.parse(JSON.stringify(regionList));
        },
        showClickHandle(index) {
            this.acticeIndex = index;
            this.regionList = [];
            if(index == 0) {
                this.loadData();
            } else {
                this.loadData(this.list[index-1].regionId);
            }
        },
        regionChange(item) {
            this.list[this.acticeIndex] = item;
            this.list.splice(this.acticeIndex + 1, this.list.length - this.acticeIndex - 1);
            if(item.hasChild == 1) {
                this.list.push({
                    regionId: '',
                    regionName: '请选择'
                })
                this.regionList = [];
                this.loadData(item.regionId);
            } else {
                this.setCheck();
                this.$emit('change', this.list);
                this.popup = false;
            }
            this.acticeIndex = this.list.length - 1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/address/addressPopup.vue